<section class="bg-image-upload">

  <!-- Upload empty state -->
  <div class="upload-zone" *ngIf="!data.image" (click)="updateBGImage($event)">
    <img src="https://prod-simpo.s3.ap-south-1.amazonaws.com/library-media/354514c1711643199684photo.png" alt=""
      style="height: 36px;">
    <p class="upload-label">Upload a file</p>
    <p class="upload-sub">or select an existing one</p>
    <span class="upload-limit">up to 32MB</span>
    <input type="file" name="myfile" accept="image/x-png,image/gif,image/jpeg,image/jpg" hidden
      (change)="updateBGImage($event)" />
  </div>

  <!-- Thumbnail + actions (matches reference) -->
  <!-- <div *ngIf="data.image" class="image-card">
    <div class="image-thumb">
      <img [src]="data.image" [alt]="data.altName" *ngIf="!data.image.includes('.mp4')">
      <video [src]="data.image" *ngIf="data.image.includes('.mp4')" autoplay loop muted></video>
    </div>
    <div class="image-actions">
      <button class="btn-replace" (click)="updateBGImage($event)">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" stroke="currentColor" viewBox="0 0 24 24" width="15"
          height="15">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8"
            d="M13.19 8.688a4.5 4.5 0 0 1 1.242 7.244l-4.5 4.5a4.5 4.5 0 0 1-6.364-6.364l1.757-1.757m13.35-.622 1.757-1.757a4.5 4.5 0 0 0-6.364-6.364l-4.5 4.5a4.5 4.5 0 0 0 1.242 7.244" />
        </svg>
        Replace
      </button>
      <input type="file" name="myfile" accept="image/x-png,image/gif,image/jpeg,image/jpg" hidden
        (change)="updateBGImage($event)" />
      <button class="btn-delete" (click)="deleteBGImage()">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" stroke="currentColor" viewBox="0 0 24 24" width="15"
          height="15">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8"
            d="m19 7-.8673 12.1425C18.0579 20.1891 17.187 21 16.1378 21H7.86224c-1.04928 0-1.92016-.8109-1.99492-1.8575L5 7m5 4v6m4-6v6m1-10V4c0-.55228-.4477-1-1-1h-4c-.55228 0-1 .44772-1 1v3M4 7h16" />
        </svg>
        Delete
      </button>
    </div>
  </div> -->

  <!-- Position sliders -->
  <div class="position-section" *ngIf="data.image">
    <p class="section-heading">Position</p>
    <!-- Horizontal -->
    <div class="slider-row">
      <label class="slider-label">
        Horizontal
      </label>

      <div class="slider-wrapper">

        <input type="range" class="modern-slider" [min]="min" [max]="max" step="5" [(ngModel)]="data.position.x"
          (input)="verticleScroll()" [style.background]="getSliderBackground(data.position.x)">
      </div>
    </div>

    <!-- Vertical -->
    <div class="slider-row">
      <label class="slider-label">
        Vertical
      </label>

      <div class="slider-wrapper">

        <input type="range" class="modern-slider" [min]="min" [max]="max" step="5" [(ngModel)]="data.position.y"
          (input)="verticleScroll()" [style.background]="getSliderBackground(data.position.y)">

      </div>
    </div>
  </div>
  <div class="position-section">

    <p class="section-heading">Color Overlay</p>
    <!-- Opacity -->
    <div class="slider-row">
      <label class="slider-label">
        Overlay
      </label>

      <div class="slider-wrapper">

        <input type="range" class="modern-slider" [min]="min" [max]="max" step="5" [(ngModel)]="data.opacity"
          (input)="opacityIncrease()" [style.background]="getSliderBackground(data.opacity)">
      </div>
    </div>
  </div>

</section>